import { unitConversionFactor } from "../../util/util";

export const getColFromSpotHarm = (
  data: any,
  colToUse: string,
  label: string,
  windUnits: string | null = null,
) => {
  const convFactor: number =
    windUnits == null ? 1 : unitConversionFactor(windUnits);

  return {
    tension: 0.3,
    label: label,
    showLine: true,
    pointRadius: 1,
    pointHitRadius: 2,
    fill: false,
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderColor: "rgba(0, 0, 0, 1)",
    borderWidth: 1,

    data: data
      .map((row: any) => ({
        x: row["etime"] * 1000,
        y: Math.round(row[colToUse] * convFactor * 10) / 10,
      }))
      .sort(
        (a: { x: number; y: number }, b: { x: number; y: number }) => a.x - b.x,
      ),
  };
};
